// Vendors
import styled from 'styled-components';
import { getStyles } from '@kubit/web-ui-components';
export const DetailComponentStyled = styled.div `
  ${({ styles }) => getStyles(styles?.container)}
`;
DetailComponentStyled.displayName = 'DetailComponentStyled';
export const DetailFigureContentContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles?.figureContentContainer)}
`;
DetailFigureContentContainerStyled.displayName = 'DetailFigureContentContainerStyled';
export const DetailContentContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles?.contentContainer)}
`;
DetailContentContainerStyled.displayName = 'DetailContentContainerStyled';
export const DetailedActionContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles?.actionContainer)}
`;
DetailedActionContainerStyled.displayName = 'DetailedActionContainerStyled';
export const DetailContentStyled = styled.div `
  ${({ styles }) => getStyles(styles?.content)}
`;
DetailContentStyled.displayName = 'DetailContentStyled';
//# sourceMappingURL=detail.component.styled.js.map